// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3ySeK","notification":"notification-5k9_K","notificationText":"notificationText-1lGNk","notificationIcon":"notificationIcon-2w0a6"};